import React from "react";

import { SnackbarProvider } from "notistack";

function NotistackProvider({ children }: { children: React.ReactNode }) {
  return (
    <SnackbarProvider
      dense
      maxSnack={5}
      hideIconVariant
      anchorOrigin={{
        vertical: "bottom",
        horizontal: "left",
      }}
      autoHideDuration={2000}
      classes={{
        containerRoot: "!z-snackbar",
        containerAnchorOriginBottomLeft: "!z-snackbar",
      }}
    >
      {children}
    </SnackbarProvider>
  );
}

export default NotistackProvider;
